<template>
  <flat-pickr
    :modelValue="value"
    :input-id="inputId"
    :placeholder="placeholder"
    :disabled="disabled"
    :inline="inline"
    :invalid-feedback="invalidFeedback"
    :state="state"
    :config="config"
    type="datetime"
    input-class="form-control"
    class="theme-custom form-control"
    @update:modelValue="onChange"
  ></flat-pickr>
</template>

<script>

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { onUnmounted } from 'vue'

export default {
  name: 'AppFlatPickr',
  components: { flatPickr },
  props: {
    value: {
      type: [Number, String, Array, Date],
      required: false,
      default: () => ''
    },
    inputId: {
      type: [Number, String, null],
      required: false
    },
    placeholder: String,
    disabled: Boolean,
    inline: Boolean,
    invalidFeedback: String,
    state: {
      type: [Boolean, null],
      required: false,
      default: () => null
    },
    config: Object,
  },
  emits: ['change'],
  setup(props, { emit }) {
    const onChange = e => {
      if (e === props.value || (!e && Array.isArray(props.value) && !props.value.length)) {
        return
      }
      emit('change', e)
    }
    const removeExistingContentFromDOM = () => {
      const flatPickrContent = document.getElementsByClassName('flatpickr-calendar')
      if (flatPickrContent.length) {
        flatPickrContent[flatPickrContent.length - 1].remove()
      }
    }

    onUnmounted(() => removeExistingContentFromDOM())

    return {
      onChange
    }
  }
}
</script>

<style lang="scss">

@import '@/core/scss/vue/libs/vue-flatpicker.scss';

</style>
